<template>
  <div class="absolute loader-full bg-loader">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageCaptureLoader'
}
</script>

<style scoped>
.absolute {
  position: absolute;
}
.loader-full {
  top: 0;
  width: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 100%;
  z-index: 1000000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,.12);
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border-style: solid;
  border-width: 6px;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
